import axios from 'axios'

// 创建axios实例
const api = axios.create({
  // 使用代理，不需要指定baseURL
  timeout: 10000,
  withCredentials: true // 允许携带Cookie
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 从本地存储获取token
    const token = localStorage.getItem('token')
    // 如果有token，则添加到请求头中
    if (token) {
      config.headers.Authorization = `${token}`
    }
    // 确保请求头中不包含无效的Cookie
    if (config.headers && config.headers.Cookie) {
      delete config.headers.Cookie
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('API请求错误:', error)
    return Promise.reject(error)
  }
)

// 认证相关API
export const authApi = {
  // 用户登录
  login(credentials) {
    return api.post('/api/user/login', credentials)
  }
}

// 游戏相关API
export const gameApi = {
  // 获取游戏列表（分页）
  getGamesList(params = {}) {
    // 添加默认分页参数
    const queryParams = {
      page: 1,
      pageSize: 10,
      ...params
    }
    return api.get('/api/game/getGamesListByPage', { params: queryParams })
  },

  // 添加游戏
  insertGame(gameData) {
    return api.post('/api/game/insertGame', gameData)
  },

  // 更新游戏
  updateGame(gameData) {
    return api.put('/api/game/updateGame', gameData)
  },

  // 删除游戏
  deleteGame(id) {
    // 按照后端要求，使用查询参数传递id
    return api.delete('/api/game/deleteGame', { params: { id: id } })
  },

  // 上传图片
  uploadImage(file) {
    const formData = new FormData()
    formData.append('image', file)
    
    return api.post('/api/common/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 获取所有平台列表
  getAllPlatforms() {
    return api.get('/api/platform/list')
  },

  // 获取游戏分类列表
  getAllGameTypes() {
    return api.get('/api/gameType/list')
  },

  // 获取游戏库列表
  getAllGameLibraries() {
    return api.get('/api/gameLibrary/list')
  }

}

export default gameApi
